// extracted by mini-css-extract-plugin
module.exports = {"cardTemplate":"styles_cardTemplate__1Aqui","templateViewStyle":"styles_templateViewStyle__3FT2f"};